<template>
  <div class="order-converted-detail">
    <div class="table-header fn-clear">
      <div class="fn-right export-btn">
        <el-button type="success" @click="exportExcel">导出Excel表</el-button>
      </div>
      <div class="fn-right table-header-right">
        <el-pagination
          :current-page.sync="search.p"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="search.limit"
          layout="sizes, prev, slot, next"
          prev-text="上一页"
          next-text="下一页"
          :total="itemTotal"
          @size-change="handleSizeChange"
        >
          <div class="chax">
            {{ search.p }}/{{
              itemTotal > 0 ? Math.ceil(itemTotal / search.limit) : 1
            }}
          </div>
        </el-pagination>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :data="dataInfo.list" border stripe @sort-change="tableSort">
        <el-table-column
          prop="create_time"
          label="创建时间"
          sortable
        />
        <el-table-column
          prop="modify_time"
          label="最后操作时间"
          sortable
        />
        <el-table-column prop="id" label="内转单号" />
        <el-table-column label="学员">
          <template slot-scope="scope">
            <div class="color-black">{{ scope.row.child_name }}</div>
            <div class="color-gray">ID：{{ scope.row.child_id }}</div>
          </template>
        </el-table-column>
        <el-table-column label="退款">
          <template slot-scope="scope">
            <div>
              <span class="color-gray">总退款金额:</span>
              ￥{{ scope.row.refundable_amount / 100 }}
            </div>
            <div>
              <span class="color-gray">内转金额:</span>
              ￥{{ scope.row.adversion_amount / 100 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="实际退款">
          <template slot-scope="scope">
            <div>￥{{ scope.row.amount / 100 }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="editor_name" label="提交人" />
        <el-table-column label="责任人">
          <template slot-scope="scope">
            <div
              v-if="scope.row.extra_supply.person_liable"
              class="color-black"
            >
              {{ scope.row.extra_supply.person_liable.person_liable_name }}
            </div>
            <div v-else class="color-black">暂无</div>
          </template>
        </el-table-column>
        <el-table-column label="订单审核状态">
          <template slot-scope="scope">
            <div class="color-black">{{ scope.row.status | orderStatus }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="getOrderInfo(scope.row)">
              {{ type == "converted" ? "查看订单" : "审核订单" }}
            </el-button>
            <el-button
              v-if="type == 'converted'"
              type="text"
              @click="refundBillDetail(scope.row)"
            >挽单信息</el-button>
            <el-button
              type="text"
              @click="orderImg(scope.row)"
            >电子合同</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="search.p"
          prev-text="上一页"
          next-text="下一页"
          :total="itemTotal"
          :page-size="search.limit"
        >
          <div class="chax">
            {{ search.p }}/{{
              itemTotal > 0 ? Math.ceil(itemTotal / search.limit) : 1
            }}
          </div>
        </el-pagination>
        <div class="insert">
          <el-button type="primary">确定</el-button>
          <span class="pagination-count">
            符合查询结果:
            <i>{{ itemTotal }}条</i>
          </span>
        </div>
      </div>
    </div>
    <el-dialog
      title="内转详情"
      :visible.sync="dialogVisible1"
      width="40%"
      :before-close="handleClose"
      class="order-detail-dialog"
    >
      <OrderConvertedInfo
        :order-detail="orderDetail"
        :type="type"
        @updateOrderList="getAdversionList"
      />
    </el-dialog>
    <el-dialog
      title="挽单信息"
      :visible.sync="dialogVisible2"
      width="40%"
      :before-close="handleClose"
    >
      <div class="refund-bill-list">
        <div class="color-black">退款过程及原因分析</div>
        <p>{{ retrieve.refundReason }}</p>
      </div>
      <div class="refund-bill-list">
        <div class="color-black">挽单过程及补救措施</div>
        <p>{{ retrieve.refundProcess }}</p>
      </div>
      <div class="refund-bill-list">
        <div class="color-black">责任分析与经验总结</div>
        <p>{{ retrieve.refundConclusion }}</p>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible3"
      title="合同预览"
      class="order-img"
    >
      <div class="agreement_picture">
        <div class="pdf">
          <iframe
            :src="src"
            frameborder="0"
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import OrderConvertedInfo from '@/components/order/OrderConvertedInfo.vue'
import Tool from '@/assets/js/tool.js'
export default {
  name: 'OrderConvertedDetail',
  components: {
    OrderConvertedInfo
  },
  filters: {
    orderStatus(value) {
      if (value == '2' || value == '6') {
        return '待财务审核'
      } else if (value == '3') {
        return '审核失败'
      } else if (value == '4') {
        return '财务打款成功'
      }
    }
  },
  props: {
    type: String,
    search: Object
  },
  data() {
    return {
      dataInfo: {},
      itemTotal: 0,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      orderDetail: {},
      retrieve: {},
      src: ''
    }
  },
  watch: {
    search: {
      deep: true,
      handler() {
        this.getAdversionList()
      }
    }
  },
  mounted() {
    this.getAdversionList()
  },
  methods: {
    exportExcel() {
      const tHeader = [
        '创建时间',
        '最后操作时间',
        '内转单号',
        '学员',
        '退款',
        '实际退款',
        '提交人',
        '责任人',
        '订单审核状态'
      ]
      const filterVal = [
        'create_time',
        'modify_time',
        'refund_id',
        'child_name',
        'price',
        'amount',
        'editor_name',
        'person_liable_name',
        'status'
      ]
      let list = JSON.stringify(this.dataInfo.list)
      list = JSON.parse(list)
      list.forEach(e => {
        e.amount = e.amount / 100
        e.price =
          '总退款金额:' +
          e.refundable_amount / 100 +
          ',内转金额:' +
          e.adversion_amount / 100
        e.child_name = e.child_name + ',ID' + e.child_id
        e.person_liable_name = e.extra_supply.person_liable
          ? e.extra_supply.person_liable.person_liable_name
          : '暂无'
        if (e.status == '2' || e.status == '6') {
          e.status = '待财务审核'
        } else if (e.status == '3') {
          e.status = '审核失败'
        } else if (e.status == '4') {
          e.status = '财务打款成功'
        }
      })
      Tool.exportExcel(tHeader, filterVal, list, '内转订单')
    },
    getAdversionList() {
      this.dialogVisible1 = false
      this.$http.getAdversionList(this.search).then(res => {
        this.dataInfo = res.data
        this.itemTotal = res.data.count - 0
      })
    },
    getOrderInfo(row) {
      this.$http.getAdversionInfo({ id: row.id }).then(res => {
        this.orderDetail = res.data
        this.dialogVisible1 = true
      })
    },
    orderImg(row) {
      this.dialogVisible3 = true
      this.src = row.extra_supply.order_img
    },
    refundBillDetail(row) {
      this.dialogVisible2 = true
      this.retrieve = row.extra_supply.retrieve || {}
    },
    handleClose() {
      this.dialogVisible1 = false
      this.dialogVisible2 = false
      this.dialogVisible3 = false
    },
    tableSort(val) {
      this.search.order_key = val.prop
      this.search.order_sort =
        val.order == 'ascending' ? '4' : val.order == 'descending' ? '3' : ''
      this.search.p = 1
      this.getAdversionList()
    },
    handleSizeChange(val) {
      this.search.limit = val
    }
  }
}
</script>

<style lang="scss">
.order-converted-detail {
  .export-btn {
    margin: 0 40px;
  }
  .flex-con {
    margin-right: 30px;
  }
  .flex-con:last-child {
    margin-right: 0;
  }
  .order-count {
    height: 160px;
    color: #fff;
    padding: 30px 0 0 30px;
    margin: 0 auto;
    background: url(../../assets/img/price-bg.png) #4c84ff right bottom
      no-repeat;
    background-size: 96px 117px;
    border-radius: 10px;
    span {
      font-size: 20px;
      margin-bottom: 25px;
    }
    p {
      font-size: 40px;
    }
  }
  .table-header {
    margin-bottom: 20px;
  }
  .el-table td {
    border: 1px solid #f5f5f5;
  }
  .refund-bill-list {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f5f5f5;
    div {
      margin-bottom: 10px;
      font-weight: bold;
    }
  }
  .order-img .el-dialog {
    height: 95% !important;
    .el-dialog__body {
      height: 90%;
    }
    .agreement_picture,
    .pdf {
      height: 100%;
    }
  }
}
</style>
